<ion-card>
  <ion-card-header class="header">
    {{ HEADER }}
  </ion-card-header>

  <ion-card-content class="indicator">
    <ion-row>
      @for (column of dataRows; track column; let i = $index) {
        <ion-col size="4">
          @for (data of column; track data; let j = $index) {
            <ion-item lines="none" class="item">
              <div slot="start" class="icon-container">
                @switch (data) {
                  @case (true) {
                    <img
                      class="active-image"
                      [src]="IMAGES.ACTIVE"
                      alt="active"
                    />
                  }
                  @case (false) {
                    <img
                      class="inactive-image"
                      [src]="IMAGES.CANCEL"
                      alt="cancel"
                    />
                  }
                  @default {
                    <div>{{ data }}</div>
                  }
                }
              </div>
              <ion-label class="label">
                {{ INDICATORS[i][j].id }}
                {{ INDICATORS[i][j].name }}
              </ion-label>
            </ion-item>
          }
        </ion-col>
      }
    </ion-row>
  </ion-card-content>
</ion-card>
